import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Api } from "../../redux/api/BaseApi";
import { Label, Error } from "@progress/kendo-react-labels";
import { MultiColumnComboBox, MultiSelect, MultiSelectFilterChangeEvent } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { UserApi } from '../../redux/api/UserApi';
import { Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import React from "react";
import useEventListener from "@use-it/event-listener";
import { IWorkstreamAssignment } from "../../types/Ticket/IWorkstreamAssignment";
import { toDigital } from "../../utils/utils";

const WorkstreamAssignment: FunctionComponent<FieldRenderProps> = props => {
    const {
        label,
        id,
        valid,
        disabled,
        optional,
        teamId,
        staff,
        showMe,
        effort,
        assignmentChanged,
        validationMessage,
    } = props;
    console.log('WorkstreamAssignment staff=', staff)
    const { data: userProfile } = Api.useGetUserProfileQuery();
    //const assignedStaff = staff?.map(ass => { return { Contact_Name: ass?.Contact_Name, Contact_Id: ass.Contact_Id } as IWorkstreamAssignment });
    let { data: staffList, isLoading: staffLoading } = UserApi.useGetStaffQuery({ teamId: teamId, includeQueues: true, includeStaffPlusForCompanyId: 0 });
    const bindStaff = staffList?.map(s => {
        return {
            Contact_Name: s?.Full_Name,
            Contact_Id: s.ID,
            Assigned_Percent: staff?.find(a => a.Contact_Id === s.ID)?.Assigned_Percent || 0,
            Assigned_Mins: (effort | 0) * (staff?.find(a => a.Contact_Id === s.ID)?.Assigned_Percent | 0) / 100
        } as IWorkstreamAssignment
    })

    const [staffFiltered, setStaff] = useState([])
    const [isOpen, setOpen] = useState(false)

    const columns = [
        { field: 'Contact_ID', header: '', width: '30px' },
        { field: 'Contact_Name', header: 'Workstream', width: '300px' },
        { field: 'Assigned_Percent', header: 'Percent', width: '50px' },
        { field: 'Time', header: 'Time', width: '50px' }
    ];

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        setStaff(filterBy(staffList?.slice(), event.filter));
    }

    useEffect(() => {
        if (showMe)
            staffList = staffList?.map(s => s.ID === userProfile?.Id ? { ...s, Full_Name: '<Me>' } : s);

        setStaff(staffList)
    }, [staffList]);

    const itemRender = (li, itemProps) => {
        const itemChildren = (
            <>                 <div>
                <input
                    type="checkbox"
                    name='selected'
                    checked={itemProps.selected}
                    onChange={(e) => itemProps.onClick(itemProps.index, e)}
                    style={{ paddingRight: '10px' }}
                />
                <span style={{ display: 'inline-block', width: '200px', paddingLeft: '10px' }}>{li.props.children}</span>
                <span style={{ display: 'inline-block', width: '200px' }}>
                    <input style={{ width: '45px', color: 'black', textAlign: 'left' }}
                        onClick={(e) => {
                            console.log('click textbox', e, itemProps)
                            e.preventDefault();
                            e.currentTarget.select();
                            e.stopPropagation();
                        }}
                        onBlur={(e) => {
                            console.log('onChange textbox', e, staff)
                            //Update the percentage
                            const percent = parseInt(e.currentTarget.value);
                            let currentStaff = staff?.slice() || [];
                            const foundIndex = currentStaff.findIndex(c => c.Contact_Id === itemProps.dataItem.Contact_Id)
                            foundIndex > -1
                                ? currentStaff[foundIndex] = { ...currentStaff[foundIndex], Assigned_Percent: percent }
                                : currentStaff.push({ Contact_Id: itemProps.dataItem.Contact_Id, Assigned_Percent: percent } as IWorkstreamAssignment);
                            assignmentChanged({ value: currentStaff });
                        }}
                        type="text" name={'Percent'} defaultValue={itemProps.dataItem.Assigned_Percent} disabled={!itemProps.selected} autoFocus={true}
                    />%
                </span>
                <label>{toDigital(itemProps.dataItem.Assigned_Mins)}</label>
            </div>
            </>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }
    const handleCheckboxChange = (event, dataItem) => {

    };

    const itemRender2 = (li, props) => {
        const children = columns.map((col, i) => {
            return col.field === "Contact_ID" ? (
                <span
                    className="k-table-td"
                    style={{
                        width: col.width,
                    }}
                    key={col.width + i}
                >
                    <Checkbox
                        onChange={(e) => handleCheckboxChange(e, props.dataItem)}
                    />
                </span>
            ) : (
                <span
                    className="k-table-td"
                    style={{
                        width: col.width,
                    }}
                    key={col.width + i}
                >
                    {props.dataItem[col.field]}
                </span>
            );

        });
        return React.cloneElement(
            li,
            {
                ...li.props,
            },
            children
        );
    };

    useEventListener("click", (e: MouseEvent) => {
        console.log('click', e)
        if (e.target && (e.target as HTMLElement)?.className?.indexOf && (e.target as HTMLElement)?.className?.indexOf('k-input-inner') == -1)
            setOpen(false);
    });
    const errorId = validationMessage ? `${id}_error` : "";
    const isValid = !validationMessage;
    const wrapper = useRef(null);
    return (
        <FieldWrapper >
            <Label
                editorId={id}
                editorValid={isValid}
                editorDisabled={disabled}
                optional={optional}>
                {label} {validationMessage && (<Error id={errorId}>{validationMessage}</Error>)}
            </Label>
            <div className={"k-form-field-wrap"} ref={wrapper}>
                <MultiSelect header={<div><span style={{ display: 'inline-block', width: '30px' }}>&nbsp;</span><span style={{ display: 'inline-block', width: '190px' }}>Name:</span><span style={{ display: 'inline-block', width: '200px' }}>Percent:</span><span>Time:</span></div>}
                    valid={isValid} validationMessage={validationMessage} opened={isOpen} onOpen={() => setOpen(true)} itemRender={itemRender} filterable={false} popupSettings={{ className: 'z500' }} onFilterChange={onFilter} onChange={assignmentChanged} data={bindStaff} value={staff} dataItemKey="Contact_Id" textField="Contact_Name" loading={staffLoading} />
            </div>
        </FieldWrapper>
    )
}

export default WorkstreamAssignment;